import { LOCAL_STORAGE_TOKEN } from "./Constants";
import jwt_decode from "jwt-decode";

class AuthProvider {
  getTokenFromLocalStorage() {
    return localStorage.getItem(LOCAL_STORAGE_TOKEN);
  }

  isAdmin() {
    if (!this.getTokenFromLocalStorage()) {
      return false;
    }
    let decoded = jwt_decode(this.getTokenFromLocalStorage());
    return decoded.scopes.split(",").includes("ROLE_ADMIN");
  }

  isExpire() {
    if (!this.getTokenFromLocalStorage()) {
      return false;
    }
    let decoded = jwt_decode(this.getTokenFromLocalStorage());
    if (decoded.exp > Date.now() / 1000) return false;
    return true;
  }
}

const authProvider = new AuthProvider();
export default authProvider;
